import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "fleet-page" }
const _hoisted_2 = { class: "top-controls" }
const _hoisted_3 = { class: "tab-toggles" }
const _hoisted_4 = { class: "catalog-card" }
const _hoisted_5 = { class: "table-container" }
const _hoisted_6 = {
  key: 0,
  class: "fleet-table"
}
const _hoisted_7 = { style: {"text-align":"center"} }
const _hoisted_8 = { class: "th-sub" }
const _hoisted_9 = { class: "fw-bold" }
const _hoisted_10 = { class: "fw-bold" }
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = { class: "battery-wrapper" }
const _hoisted_13 = { class: "battery-bar-container" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "fleet-table makes-table"
}
const _hoisted_16 = { class: "fw-bold" }
const _hoisted_17 = { class: "capacity-badge" }
const _hoisted_18 = { class: "fw-bold" }
const _hoisted_19 = { class: "status-logs" }
const _hoisted_20 = { class: "status-log-row" }
const _hoisted_21 = { class: "log-text" }
const _hoisted_22 = { class: "status-log-row" }
const _hoisted_23 = { class: "log-text" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "catalog-footer" }
const _hoisted_26 = { class: "results-text" }
const _hoisted_27 = { class: "analytics-row" }
const _hoisted_28 = { class: "analytics-card total-models" }
const _hoisted_29 = { class: "card-header" }
const _hoisted_30 = { class: "card-badge growth-badge" }
const _hoisted_31 = { class: "card-title" }
const _hoisted_32 = { class: "card-value" }
const _hoisted_33 = { class: "unit" }
const _hoisted_34 = { class: "analytics-card active-resort" }
const _hoisted_35 = { class: "card-header" }
const _hoisted_36 = { class: "card-badge ready-badge" }
const _hoisted_37 = { class: "card-title" }
const _hoisted_38 = { class: "card-value" }
const _hoisted_39 = { class: "unit" }
const _hoisted_40 = { class: "analytics-card low-battery" }
const _hoisted_41 = { class: "card-header" }
const _hoisted_42 = { class: "card-badge action-badge" }
const _hoisted_43 = { class: "card-title" }
const _hoisted_44 = { class: "card-value" }
const _hoisted_45 = { class: "unit" }

import { onMounted, ref, computed, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Search, Edit, Bell, Van } from '@element-plus/icons-vue'

import CommonError from '@/components/CommonError.vue'
import { routeNames } from '@/router/route-names'
import { useGolfVehiclesStore } from '@/store/golf-vehicles'
import type { GolfCarProfile } from '@/api/golf'
import { useAuthStore } from '@/store/auth'
import { useGolfHeaderStore } from '@/store/golf-header'
import { useGolfI18n } from '@/composables/useGolfI18n'

const pageSize = 12


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const golfStore = useGolfVehiclesStore()
const authStore = useAuthStore()
const headerStore = useGolfHeaderStore()
const { t } = useGolfI18n()

const activeTab = ref<'models' | 'makes'>((route.query.tab as 'models' | 'makes') || 'models')

const selectTab = (tab: 'models' | 'makes') => {
  activeTab.value = tab
  currentPage.value = 1
}

watch(activeTab, (newTab) => {
  router.replace({ query: { ...route.query, tab: newTab } })
})
const currentPage = ref(1)
const searchQuery = computed({
  get: () => headerStore.searchQuery,
  set: (val) => headerStore.setSearchQuery(val)
})
const allProfiles = computed(() => {
  return Array.isArray(golfStore.profiles) ? golfStore.profiles : []
})

const allAssets = computed(() => {
  const assets: any[] = []
  allProfiles.value.forEach(profile => {
    if (profile.assets && profile.assets.length > 0) {
      profile.assets.forEach((asset: any) => {
        assets.push({
          ...asset,
          profile_id: profile.id,
          make_name: profile.name,
          make_model: profile.model_name,
          seats: profile.seats,
          tariff: (profile as any).tariff
        })
      })
    }
  })
  return assets
})

const filteredModels = computed(() => {
  let list = allAssets.value
  const query = searchQuery.value.trim().toLowerCase()
  if (query) {
    list = list.filter((a: any) =>
      a.id.toLowerCase().includes(query) ||
      a.make_name.toLowerCase().includes(query)
    )
  }
  return list
})

const filteredMakes = computed(() => {
  let list = allProfiles.value
  const query = searchQuery.value.trim().toLowerCase()
  if (query) {
    list = list.filter((p: any) =>
      p.name.toLowerCase().includes(query) ||
      p.model_name.toLowerCase().includes(query)
    )
  }
  return list
})

const currentListLength = computed(() => {
  return activeTab.value === 'models' ? filteredModels.value.length : filteredMakes.value.length
})

const paginationStart = computed(() => {
  return currentListLength.value === 0 ? 0 : (currentPage.value - 1) * pageSize + 1
})

const paginationEnd = computed(() => {
  return Math.min(currentPage.value * pageSize, currentListLength.value)
})

const paginatedModels = computed(() => {
  const start = (currentPage.value - 1) * pageSize
  return filteredModels.value.slice(start, start + pageSize)
})

const paginatedMakes = computed(() => {
  const start = (currentPage.value - 1) * pageSize
  return filteredMakes.value.slice(start, start + pageSize)
})

const onRetryPress = () => {
  golfStore.fetchProfiles()
}

onMounted(() => {
  headerStore.setHeaderInfo('golf.fleet.title', true, 'golf.header.search_placeholder')
  golfStore.fetchProfiles()
})

const handleEditModel = (asset: any) => {
  router.push({ name: routeNames.golfCarCreateModel, query: { id: asset.id } })
}

const handleEditMake = (make: GolfCarProfile) => {
  router.push({ name: routeNames.golfCarCreateMake, query: { id: make.id } })
}

const handleAddClick = () => {
  if (activeTab.value === 'makes') {
    router.push({ name: routeNames.golfCarCreateMake })
  } else {
    router.push({ name: routeNames.golfCarCreateModel })
  }
}

const getBatteryColor = (percentage: number) => {
  if (percentage <= 20) return '#BA1A1A'
  return '#009A81'
}

const getStatusLabel = (status: string) => {
  switch (status) {
    case 'active': return t('golf.fleet.status_active') || 'Active'
    case 'in_use': return t('golf.fleet.status_in_use') || 'In Use'
    case 'maintenance':
    case 'inactive': return t('golf.fleet.status_maintenance') || 'Maintenance'
    default: return t('golf.fleet.status_active') || 'Active'
  }
}

const getStatusBadgeClass = (status: string) => {
  switch (status) {
    case 'active': return 'badge-active'
    case 'in_use': return 'badge-in-use'
    case 'maintenance':
    case 'inactive': return 'badge-maintenance'
    default: return 'badge-active'
  }
}

const getAssetCount = (car: GolfCarProfile) => {
  return car.assets ? car.assets.length : 0
}

const getActiveCount = (car: GolfCarProfile) => {
  return car.assets ? car.assets.filter((a:any) => a.status === 'active' || a.status === 'in_use').length : 0
}

const getMaintenanceCount = (car: GolfCarProfile) => {
  return car.assets ? car.assets.filter((a:any) => a.status === 'maintenance' || a.status === 'inactive').length : 0
}

const totalFleetModels = computed(() => {
  return allAssets.value.length
})

const activeInResort = computed(() => {
  return allAssets.value.filter(a => a.status === 'active' || a.status === 'in_use').length
})

const lowBatteryAlerts = computed(() => {
  return allAssets.value.filter(a => (a.battery_pct || 0) <= 20 || a.status === 'maintenance').length
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(golfStore).error)
      ? (_openBlock(), _createBlock(CommonError, {
          key: 0,
          errorMessage: _unref(golfStore).error,
          onRetryPress: onRetryPress
        }, null, 8, ["errorMessage"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["tab-btn", { active: activeTab.value === 'models' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (selectTab('models')))
          }, _toDisplayString(_ctx.$t('golf.fleet.tab_models') || 'Golf Models'), 3),
          _createElementVNode("button", {
            class: _normalizeClass(["tab-btn", { active: activeTab.value === 'makes' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (selectTab('makes')))
          }, _toDisplayString(_ctx.$t('golf.fleet.tab_makes') || 'Golf Makes'), 3)
        ]),
        _createElementVNode("button", {
          class: "add-model-btn",
          onClick: handleAddClick
        }, " + " + _toDisplayString(activeTab.value === 'makes'
            ? _ctx.$t('golf.fleet.add_make')
            : _ctx.$t('golf.fleet.add_model')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (activeTab.value === 'models')
            ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('golf.fleet.model_id')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('golf.fleet.assigned_make')), 1),
                    _createElementVNode("th", _hoisted_7, [
                      _createTextVNode(_toDisplayString(_ctx.$t('golf.fleet.iot_telemetry')), 1),
                      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('golf.fleet.battery_label')), 1)
                    ]),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('golf.trips.current_status')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('golf.fleet.actions')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedModels.value, (asset) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: asset.id
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(asset.asset_number || '#' + asset.id.slice(0, 8)), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(asset.make_name), 1),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(asset.seats || 0) + " " + _toDisplayString(_ctx.$t('golf.trips.seats')), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", {
                              class: "battery-bar-fill",
                              style: _normalizeStyle({
                        width: (asset.battery_pct || 0) + '%',
                        backgroundColor: getBatteryColor(
                          asset.battery_pct || 0
                        ),
                      })
                            }, null, 4)
                          ]),
                          _createElementVNode("span", {
                            class: "battery-pct",
                            style: _normalizeStyle({ color: getBatteryColor(asset.battery_pct || 0) })
                          }, _toDisplayString(asset.battery_pct || 0) + "%", 5)
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["status-badge", getStatusBadgeClass(asset.status || 'active')])
                        }, [
                          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "dot" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(getStatusLabel(asset.status || 'active')), 1)
                        ], 2)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "action-edit-btn",
                          onClick: ($event: any) => (handleEditModel(asset))
                        }, _cache[5] || (_cache[5] = [
                          _createElementVNode("img", {
                            src: "/icons_golf_module/Fleet_edit icon.svg",
                            alt: "Edit",
                            style: {"width":"20px","height":"20px"}
                          }, null, -1)
                        ]), 8, _hoisted_14)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (activeTab.value === 'makes')
            ? (_openBlock(), _createElementBlock("table", _hoisted_15, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('golf.fleet.assigned_make')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('golf.fleet.capacity')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('golf.fleet.total_inventory')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('golf.fleet.fleet_status_logs')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('golf.fleet.actions')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedMakes.value, (make) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: make.id
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(make.name), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_17, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createElementVNode("svg", {
                                viewBox: "0 0 1024 1024",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("path", {
                                  fill: "currentColor",
                                  d: "M512 512a192 192 0 1 0 0-384 192 192 0 0 0 0 384zm0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512zm320 320v-48c0-103.95-81.8-190.5-184.8-191.95A196 196 0 0 0 512 608a196 196 0 0 0-135.2 48.05C273.8 657.5 192 744.05 192 848v48h64v-48c0-72.13 54.8-132.85 125.7-139.73A132 132 0 0 1 512 672a132 132 0 0 1 130.3 36.27C713.2 715.15 768 775.87 768 848v48h64z"
                                })
                              ], -1)
                            ])),
                            _: 1,
                            __: [6]
                          }),
                          _createTextVNode(" " + _toDisplayString(make.seats || 0) + " " + _toDisplayString(_ctx.$t('golf.trips.seats')), 1)
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('golf.fleet.count_models', { count: getAssetCount(make) })), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "dot bg-teal" }, null, -1)),
                            _createElementVNode("span", _hoisted_21, _toDisplayString(getActiveCount(make)) + " " + _toDisplayString(_ctx.$t('golf.fleet.status_active')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "dot bg-orange" }, null, -1)),
                            _createElementVNode("span", _hoisted_23, _toDisplayString(getMaintenanceCount(make)) + " " + _toDisplayString(_ctx.$t('golf.fleet.status_maintenance')), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "action-edit-btn",
                          onClick: ($event: any) => (handleEditMake(make))
                        }, _cache[9] || (_cache[9] = [
                          _createElementVNode("img", {
                            src: "/icons_golf_module/Fleet_edit icon.svg",
                            alt: "Edit",
                            style: {"width":"20px","height":"20px"}
                          }, null, -1)
                        ]), 8, _hoisted_24)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("span", _hoisted_26, _toDisplayString(activeTab.value === 'models'
              ? _ctx.$t('golf.fleet.showing_active_assets', {
                  start: paginationStart.value,
                  end: paginationEnd.value,
                  total: currentListLength.value,
                })
              : _ctx.$t('golf.fleet.showing_active_profiles', {
                  start: paginationStart.value,
                  end: paginationEnd.value,
                  total: currentListLength.value,
                })), 1),
          _createVNode(_component_el_pagination, {
            "current-page": currentPage.value,
            "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((currentPage).value = $event)),
            "page-size": pageSize,
            total: currentListLength.value,
            layout: "prev, pager, next",
            small: ""
          }, null, 8, ["current-page", "total"])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _cache[10] || (_cache[10] = _createElementVNode("div", {
              class: "card-icon",
              style: {"border":"none"}
            }, [
              _createElementVNode("img", {
                src: "/icons_golf_module/Fleet managment Growth.svg",
                alt: "Growth",
                style: {"width":"24px","height":"24px"}
              })
            ], -1)),
            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('golf.fleet.growth_plus4')), 1)
          ]),
          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('golf.fleet.total_fleet_models')), 1),
          _createElementVNode("div", _hoisted_32, [
            _createTextVNode(_toDisplayString(totalFleetModels.value) + " ", 1),
            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('golf.common.units')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[11] || (_cache[11] = _createElementVNode("div", {
              class: "card-icon",
              style: {"border":"none"}
            }, [
              _createElementVNode("img", {
                src: "/icons_golf_module/fleet managment Ready.svg",
                alt: "Ready",
                style: {"width":"24px","height":"24px"}
              })
            ], -1)),
            _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('golf.fleet.ready')), 1)
          ]),
          _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('golf.fleet.active_in_resort')), 1),
          _createElementVNode("div", _hoisted_38, [
            _createTextVNode(_toDisplayString(activeInResort.value) + " ", 1),
            _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('golf.common.units')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _cache[12] || (_cache[12] = _createElementVNode("div", {
              class: "card-icon",
              style: {"border":"none"}
            }, [
              _createElementVNode("img", {
                src: "/icons_golf_module/Fleet managment Action required.svg",
                alt: "Action Required",
                style: {"width":"24px","height":"24px"}
              })
            ], -1)),
            _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('golf.trips.action_required')), 1)
          ]),
          _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('golf.fleet.low_battery_alerts')), 1),
          _createElementVNode("div", _hoisted_44, [
            _createTextVNode(_toDisplayString(lowBatteryAlerts.value) + " ", 1),
            _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('golf.common.units')), 1)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})